import commonMixin from '@/mixin/common'
import {addressAdd, addressDelete, addressUpdate, addressDetail} from '@/api/server/address'
export default {
  name: 'AddressEditPage',
  mixins: [commonMixin],
  data () {
    return {
      id: null,
      form: {
        name: null,
        tel: null,
        address: null
      }
    }
  },
  components: {
  },
  computed: {
    isEdit () {
        if (this.id) {
            return true
        } else {
            return this.id
        }
    }
  },
  methods: {
    onDelete () {
        let id = this.id
        if (!id) {
            return false
        }
        addressDelete(id).then( (res)=> {
            if (res.code === 200) {
                this.success('删除成功')
                this.list = res.data
                this.$router.push({name: 'user-address'})
            } else {
                this.warning(res.message)
            }
        })
    },
    onSubmit () {
        if (this.id) {
            this.updateAddress()
        } else {
            this.saveAddress()
        }
    },
    updateAddress () {
        if (!this.form.name) {
            this.error('请正确填写收货人')
            return false
        }
        if (!this.isPhone(this.form.tel)) {
            this.error('请正确填写手机号码')
            return false
        }
        if (!this.form.address) {
            this.error('请正确填写详细地址')
            return false
        }
        let form = this.form
        form['is_default'] = this.isDefault
        addressUpdate(this.form).then( (res) => {
            if (res.code === 200) {
                this.success('保存成功')
                this.list = res.data
                this.dialogAddrVisible = false
                this._resetAddress()
                this.$router.push({name: 'user-address'})
            } else {
                this.warning(res.message)
            }
        })
    },
    saveAddress () {
        if (!this.form.name) {
            this.error('请正确填写收货人')
            return false
        }
        if (!this.isPhone(this.form.tel)) {
            this.error('请正确填写手机号码')
            return false
        }
        if (!this.form.address) {
            this.error('请正确填写详细地址')
            return false
        }
        // form['is_default'] = this.isDefault
        addressAdd(this.form).then( (res) => {
            if (res.code === 200) {
                this.success('保存成功')
                this.list = res.data
                this.dialogAddrVisible = false
                this._resetAddress()
                this.$router.push({name: 'user-address'})
            } else {
                this.warning(res.message)
            }
        })
      
    },
    _resetAddress () {
        this.id = 0
        this.valueArea = null
        this.form = {
            name: null,
            tel: null,
            province: null,
            city: null,
            region: null,
            province_code: null,
            city_code: null,
            region_code: null,
            address: null,
            is_default: 0
        }
    },
    _getDetail () {
        let query = {
            id: this.id
        }
        addressDetail(query).then( (res)=> {
            if (res.code === 200 && res.data) {
                this.form = res.data
            }
        })
    },
    reset () {
        if (this.id) {
            this._getDetail()
        }
    },
    handleRoute (route) {
        if (route.name === 'user-address-edit') {
            let id = this.$route.query.id
            this.id = id
            this.reset()
        }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}